<script lang="ts" setup>
import MBanner from "../../../../medicus/MBanner";
defineProps<{
  alerts: Array<{}>;

  type?: string;

  expanded?: boolean;
  expand?: boolean;

  label?: string;
  renderAlertWithHtml?: boolean;
}>();
</script>
<template>
  <m-banner
    :expanded="expanded"
    :expand="expand"
    :type="type"
    :count="alerts.length"
    :label="label"
    class="safety-alert-banner"
  >
    <ul :class="alerts.length === 1 ? '' : 'multiple-alerts'">
      <li v-for="(alert, index) in alerts" :key="`alert_${index}`">
        <span v-if="true === renderAlertWithHtml" v-html="alert" />
        <span v-else>
          {{ alert }}
        </span>
      </li>
    </ul>
  </m-banner>
</template>
<style lang="scss">
.safety-alert-banner {
  padding-top: 0;

  .banner-expandable__content {
    padding-bottom: 8px;
  }

  ul {
    padding-right: 16px;
    // ENG-21423 a single alert has no bullet, so align it with the label
    padding-inline-start: 0;
    list-style: none;

    &.multiple-alerts {
      padding-inline-start: 64px;
      list-style: disc;

      &.lesser-padding {
        padding-inline-start: 20px;
      }
    }
  }
}
</style>
